// API URL utility - works in both preview and production environments
export const getApiUrl = () => {
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    
    // Production domain - always use same origin
    if (hostname === 'fin.revurge.com') {
      return 'https://fin.revurge.com';
    }
    
    // Localhost development
    if (hostname === 'localhost') {
      return 'http://localhost:8001';
    }
    
    // Preview environments - use same origin
    if (hostname.includes('preview.emergentagent.com')) {
      return window.location.origin;
    }
    
    // Fallback to environment variable or same origin
    return process.env.REACT_APP_BACKEND_URL || window.location.origin;
  }
  return process.env.REACT_APP_BACKEND_URL || '';
};

export const API_URL = getApiUrl();
